/* eslint-disable no-param-reassign */
import nanoid from 'nanoid'

/**
 * Função que adiciona uma key para ser usada pelo react a um objeto
 * @param {*} object qualquer objeto valido no JavaScript
 * @returns o objeto com a key caso objeto seja valido ou não contenha key
 * @throws Error quando o objeto é nulo, undefined ou já contém uma key
 */
export const addKeyToObject = (object) => {
  if (typeof object !== 'object' || object === null)
    throw new Error('The entry is not valid, cannot add or remove properties')

  if (object.key) return object

  object.key = nanoid()
  return object
}

/**
 * Função que adiciona uma key para ser usada pelo react a todos objetos do array
 * @param {*} objectsArray array de quaisquer objetos validos no JavaScript
 * @returns um array de objetos com a key caso todos os objetos sejam válidos ou não contenham key
 * @throws Error quando o array está vazio ou não é um array
 */
export const addKeyToObjectsArray = (objectsArray) => {
  if (!objectsArray)
    throw new Error('The passed member is not an Array or is empty')
  return objectsArray.map((object) => {
    return addKeyToObject(object)
  })
}
